function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgNotificationsScreenIcon = function SvgNotificationsScreenIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.105,
    d: "M22.106 28.421v8.421A2.105 2.105 0 0 1 20 38.947H3.158a2.105 2.105 0 0 1-2.105-2.105V7.368a2.105 2.105 0 0 1 2.105-2.105H7.37"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.accentFillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.105,
    d: "M11.58 32.632v.02m2.105-31.6h21.053v16.843h-6.316L20 22.105v-4.21h-6.316z"
  }));
};
export default SvgNotificationsScreenIcon;